/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5f5f11e14311b0db475b118e61a3a9148d1bb2d6";
